import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { ENUM__connection_state } from '@/enums/ENUM__connection_state';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { EZIndexes } from '@/enums/EZIndexes';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_app_info, use_slice_network, use_slice_ui, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { set_timeout } from '@/utils/utils_client';
import { ENUM__user_role } from '@shared/dto/+user/entity/ENUM__user_role';
import { useRef, useState } from 'react';

// todo: add button close for admin role
export function SPLASH__loading() {
  const { is_all_data_loaded } = use_slice_workspace(['is_all_data_loaded']);
  const { app_info } = use_slice_app_info(['app_info']);
  const { user_role } = use_slice_user(['user_role']);
  const { global__page_type } = use_slice_ui(['global__page_type']);
  const { state } = use_slice_network(['state']);

  /*
   *
   */

  const [visible, set_visible] = useState(!is_all_data_loaded);
  const ref_opacity = useRef('opacity-100');

  /*
   * EFFECTS
   */

  use_effect(() => {
    let timeout_id = NaN;

    if (should_hide()) {
      ref_opacity.current = 'opacity-0';
      window.cursor_loading.disable();

      timeout_id = set_timeout(() => set_visible(false), CONSTANTS_TIME__client.TIMEOUT_DELAY_SPLASH_HIDE);
    } else {
      ref_opacity.current = 'opacity-100';
      window.cursor_loading.enable();

      set_visible(true);
    }

    return () => {
      clearTimeout(timeout_id);
      ref_opacity.current = 'opacity-100';
    };
  }, [is_all_data_loaded, app_info, user_role, global__page_type, state]);

  /*
   * METHODS
   */

  function need_hide_during_maintenance() {
    if (!app_info.is_maintenance_mode_enabled()) return true; //maintenance mode is disabled
    if (user_role == ENUM__user_role.ADMIN) return true; //user is admin and can view app during maintenance
    if (global__page_type == ENUM__page_type.AUTH) return true; //we should show page auth for admins

    return false;
  }

  function should_hide() {
    if (!is_all_data_loaded) return false;
    if (state != ENUM__connection_state.CONNECTION_ESTABLISHED) return false;
    if (!app_info.is_maintenance_mode_enabled()) return true;
    if (global__page_type === ENUM__page_type.AUTH) return true;

    return false;
  }

  /*
   * RENDERS
   */

  function try_render_label_maintenance() {
    if (!app_info.is_maintenance_mode_enabled()) return null;

    return <span className="gradient-text-theme-neutral text-xl font-bold text-page-foreground">MAINTENANCE</span>;
  }

  /*
   * HTML
   */

  if (!visible) return null;

  return (
    <div
      className={`
        fixed inset-0 size-full 
        transition-opacity duration-500
        flex-center
        ${window.cursor_loading.enabled ? 'cursor-none' : ''}
        ${EZIndexes.SPLASH_SCREEN_LOADING} bg-black/50
        ${ref_opacity.current}
      `}
    >
      <div
        className={`animation-gradient-neutral rounded-for-gradient-2 flex items-center justify-center w-[464px]
             ${app_info.is_maintenance_mode_enabled() ? 'h-[140px]' : 'h-[124px]'}`}
      >
        <div className={` flex flex-col flex-center gap-4 ${EZIndexes.Z_2} w-[calc(100%-4px)] h-[calc(100%-4px)] rounded-2xl border border-bar-border bg-bar`}>
          <h1 className="gradient-text-theme-neutral text-[2rem] leading-[2.5rem] font-[700] text-page-foreground">ULTIMATE DIFFUSION</h1>
          {try_render_label_maintenance()}
        </div>
      </div>
    </div>
  );
}
